import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-799fc58d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tags-inner" }

import { watch, ref, reactive } from 'vue'
  import TheModel from '@/components/PopModelTags/TheModel.vue'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    dataList: {
      type: Array,
      default: []
    },
    widgetConfig: {
      type: Object,
      default: {},
    }
  },
  emits: ['update:data'],
  setup(__props, { emit }) {

const props = __props;

  
  const modelData = ref([])
  
  
  // console.log('props.data', props.widgetConfig);
  
  watch(
    () => props.data,
    (newValue, oldValue) => {
      modelData.value = JSON.parse(JSON.stringify(newValue || []))
      emit('update:data', newValue)

    },
    { immediate: true }
  )
  const modelConfig = reactive({
    visible: false,
    data: [],
  })
  // watch(
  //   () => modelConfig.data,
  //   (newValue) => {
  //     emit('update:data', newValue)
  //   },
  //   { immediate: true }
  // )
  
  const addEvent = () => {
    modelConfig.data = JSON.parse(JSON.stringify(modelData.value))
    modelConfig.visible = true
  }
  
  const deleteTag = (index) => {
    modelData.value.splice(index, 1)
    emit('update:data', modelData.value)
  }
  
return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "tags-main",
      style: {"width":"100%"},
      onClick: addEvent
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((modelData.value && modelData.value.slice(0, 7)) || [], (item, index) => {
          return (_openBlock(), _createBlock(_component_el_tooltip, {
            key: index,
            placement: "top",
            effect: "light",
            disabled: item.length < 3
          }, {
            content: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                closable: "",
                type: "info",
                onClose: ($event: any) => (deleteTag(index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["onClose"])
            ]),
            _: 2
          }, 1032, ["disabled"]))
        }), 128)),
        _createVNode(_component_el_tag, {
          size: "default",
          type: "info",
          style: {"border-radius":"50%"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(modelData.value.length), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(TheModel, {
      visible: modelConfig.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((modelConfig.visible) = $event)),
      data: modelData.value,
      "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => ((modelData).value = $event)),
      "apk-list": __props.dataList,
      title: __props.widgetConfig.dialogTitle
    }, null, 8, ["visible", "data", "apk-list", "title"])
  ], 64))
}
}

})